
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Rack, SalePurchaseParty } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { insertRetailerEntry } from '../../Store/PHPSlice/retailerAPi';


const RetailerEntry = ({ data }) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        retailerNm: '',
        adrs: '',
        mobno: '',
        userId: userdata?.ID
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobno') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'mobno' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const [errors, setErrors] = useState({});
    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name
        if (!formData.retailerNm.trim()) {
            // setErrors({ rackNm: 'Rack Name is required' });
            alert('Retailer Name is required');
            return;
        }

        setLoading(true);

        try {
            const result = await dispatch(insertRetailerEntry(formData)).unwrap();
            console.log('POST request successful!', result);
            alert("Reatailer Added Successful");
            if (data === '1') {
                window.close();
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }


    };


    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
        // {
        //     label: 'Location',
        //     id: 'locId',
        //     options: loclist?.data || [],
        //     value: formData.locId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
        //     getOptionLabel: (option) => option.locNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    const fields = [
        { label: 'Retailer Name', name: 'retailerNm' },
        { label: 'Address', name: 'adrs' },
        { label: 'Mobile No.', name: 'mobno' }
    ];


    return (
        <>
            {data === '1' ? null : <Titlebar data={SalePurchaseParty} />}
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Retailer Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>
        </>
    );
}

export default RetailerEntry;
